export default "__VITE_ASSET__DFAFExIw__"